import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Theme from '../ui/Theme';
import Search from '../../assets/Search';
const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: Theme.palette.secondary.main,
    height: '42px',
    paddingLeft: '20px',
  },
  input: {
    border: '0px',
    backgroundColor: Theme.palette.secondary.main,
    height: '40px',
    width: '100%',
    outlineWidth: 0,
    fontWeight: 500,
    fontSize: '14px',
    paddingLeft: '20px',
  },
  searchIcon: {
    backgroundColor: Theme.palette.ternary.main,
    height: '44px',
    paddingTop: '10px',
    textAlign: 'center',
  },
}));

const SearchBox = (props) => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item xs={10}>
        <input
          type="text"
          placeholder={props.selectedTab === 1 ? 'Search in Dealerships' : 'Search in Journeys'}
          className={classes.input}
          onChange={props.handleChange}
        />
      </Grid>
      <Grid item xs={2} className={classes.searchIcon}>
        <Search />
      </Grid>
    </Grid>
  );
};

export default SearchBox;
